import { Injectable }       from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild
}                           from '@angular/router';
import { AuthService }      from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  modul = [
    {
      name: "Admin", 
      value: "admin",
      link: [
        {url: 'my-profile',type: 'read_data', p: true},
      ]
    },
    {
      name: "Container", 
      value: "container",
      link: [
        {url: 'dashboard',type: 'read_data', p: null},
        {url: 'list',type: 'read_data', p: null},
        {url: 'form',type: 'read_data', p: null},
        {url: 'condition',type: 'read_data', p: null},
        {url: 'multi-container',type: 'read_data', p: null},
      ]
    },
    {
      name: "Movement", 
      value: "movement",
      link: [
        {url: 'list',type: 'read_data', p: null},
        {url: 'list2',type: 'read_data', p: null},
        {url: 'details',type: 'read_data', p: null},
        {url: 'cont',type: 'read_data', p: null},
        {url: 'multi-movement',type: 'read_data', p: null},
        {url: 'multi-load',type: 'read_data', p: null},
        {url: 'multi-del',type: 'read_data', p: null},
        {url: 'shipment',type: 'read_data', p: null},
        {url: 'report',type: 'read_data', p: null},
        {url: 'container',type: 'read_data', p: null},
      ]
    },
    {
      name: "Vessel loading", 
      value: "vessel-load",
      link: [
        {url: 'load',type: 'read_data', p: null},
        {url: 'import',type: 'read_data', p: null},
        {url: 'voyage',type: 'read_data', p: null},
      ]
    },
    {
      name: "Lease", 
      value: "lease",
      link: [
        {url: 'container',type: 'read_data', p: null},
        {url: 'list', type: 'read_data', p: null},
        {url: 'details', type: 'read_data', p: null}, 
        {url: 'lease-detail',type: 'read_data', p: null},
        {url: 'off-quota',type: 'read_data', p: null},
        {url: 'lease-invoice',type: 'read_data', p: null},
      ]
    },
    {
      name: "Accounting", 
      value: "acc",
      link: [
        {url: 'sel-rev-ledger',type: 'read_data', p: null},
        {url: 'sel-cost-ledger',type: 'read_data', p: null},
      ]
    },
    {
      name: "Sel", 
      value: "sel",
      link: [
        {url: 'sel-book',type: 'read_data', p: null},
        {url: 'sel-report',type: 'read_data', p: null},
        {url: 'sel-invoice',type: 'read_data', p: null},
        {url: 'sel-contract',type: 'read_data', p: null},
      ]
    },
    {
      name: "Partner", 
      value: "partner",
      link: [
        {url: 'supplier',type: 'read_data', p: null},
        {url: 'customer',type: 'read_data', p: null},
      ]
    },
    {
      name: "Settings", 
      value: "setting",
      link: [
        {url: 'vessel',type: 'read_data', p: null},
        {url: 'voyage',type: 'read_data', p: null},
      ]
    },
    {
      name: "Human Resources", 
      value: "human-resources",
      link: [
        {url: 'user_time',type: 'read_data', p: null},
      ]
    },
  ];
  url;
  constructor(private authService: AuthService, private router: Router) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    return this.checkLogin(url);
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  getPermission(url){
    let arr = url.split('/');
    let modul = this.modul.find(item => item.value == arr[2]);
    let link = modul.link.find(item => item.url == arr[3]);
    // check duong dan co ton tai khong
    if(!link) return 0; 

    // check duong dan co uu tien khong - uu tien = ko check permission database
    if(link.p) return 1; 

    // check permission database
    let check = this.authService.getPermission(modul.value, link.type);
    
    if(check != 1) check = 0;
    return check;
  }

  checkLogin(url: string): boolean {
    if (this.authService.isLoggedIn) {
      let check = this.getPermission(url);
      // neu permission true
      if(check == 1){
        this.url = url;
        return true;
      }

      alert('No permission/Action: ' + url);
      return false;
    } else {
      this.authService.redirectUrl = url;
      // Navigate to the login page with extras
      this.router.navigate(['/login']);
      return false;
    }
  }
}